// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1sL6L","signatureBlock":"Footer_signatureBlock__1oXGu","signature":"Footer_signature__2YKVM"};